import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const FORM_CONTENT_BLOCKER_CONTEXT_SYMBOL = Symbol();
const useFormContentBlocker = ()=>useImmutableContext(FORM_CONTENT_BLOCKER_CONTEXT_SYMBOL);
const useFormContentBlockerProvider = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return useImmutableContextProvider(FORM_CONTENT_BLOCKER_CONTEXT_SYMBOL, ...args);
};
export { useFormContentBlocker, useFormContentBlockerProvider };
